import _createClass from "@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
var Column = /*#__PURE__*/_createClass(function Column(options) {
  _classCallCheck(this, Column);
  this.type = options.type || 'column';
  this.data = options.data || {
    key: '',
    name: '',
    bold: false,
    italic: false
  };
  this.children = options.children || [{
    text: ''
  }];
});
var generateColumn = function generateColumn(options) {
  return Object.assign({}, new Column(options));
};
export default generateColumn;